import getRoute from '../../scripts/utils/getRoute';

const getCartVariantsAtLimit = async () : Promise<{[key: string]: number}> => {
  try {
    const res = await fetch(getRoute() + 'cart?view=stock-check');
    const ret = await res.json();
    return ret
  } catch (e) {
    console.info(e)
    return {}
  }
}
export default getCartVariantsAtLimit